import Event from './event';

export default class XEventSource extends Event {
  constructor(sseUri, timeout = 15000) {
    super();
    this.eventsource = new EventSource(sseUri);
    this.eventsource.xeventsource = this;
    this.timeout = timeout;

    this.init();

    if (timeout) {
      this.timeId = setTimeout(() => {
        this.errorMessage = 'TIMEOUT';
        this.eventsource.close();
      }, this.timeout);
    }
  }

  init() {
    this.eventsource.addEventListener('open', this.handleOpen);
    this.eventsource.addEventListener('message', this.handleMessage);
    this.eventsource.addEventListener('error', this.handleError);
  }

  handleOpen(e) {
    const { xeventsource } = this;
    clearTimeout(xeventsource.timeId);

    xeventsource.emit('open', e);
    console.log('----eventsource----：open')
  }

  handleMessage(e) {
    const { xeventsource } = this;
    xeventsource.emit('message', e);
    console.log('----eventsource----：message', e)
  }

  handleError(e) {
    const { xeventsource } = this;
    clearTimeout(xeventsource.timeId);

    xeventsource.emit('error', e);
    console.log('----eventsource----：error', e)
  }

  abort() {
    this.errorMessage = 'ABORT';
    this.eventsource.close();
    console.log('----eventsource----：abort')
  }

  destroy() {
    console.log('----eventsource----：destroy')
    clearTimeout(this.timeId);
    this.eventsource.close();
    this.eventsource.removeEventListener('open', this.handleOpen);
    this.eventsource.removeEventListener('message', this.handleMessage);
    this.eventsource.removeEventListener('error', this.handleError);
  }
}
